import router from './router'
import AuthMessages from './localization'
import useAuthStore from './store'

export default {
  router,
  useAuthStore,
  localization: AuthMessages,
}
